'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const HeartIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.2 7.99998C19.9 6.09998 18.5 4.89998 17.3 4.49998C15.1 3.79998 13.4 5.29998 12.7 6.09998L12 6.79998L11.4 6.09998C10.6 5.29998 9.00002 3.89998 6.70002 4.49998C5.50002 4.89998 4.10002 6.09998 3.80002 7.99998C3.50002 9.69998 3.90002 13.9 12 19.6C20.1 13.9 20.5 9.69998 20.2 7.99998Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpHeartIcon = forwardRef(HeartIcon);

export { VpHeartIcon as default };
